import { TemplateFilter } from "../TemplateList.types";
import { TemplateSectionProps } from "../TemplateSection/TemplateSection.types";

const sectionPropsByFilterMap: {
  [key in TemplateFilter]: Partial<
    Pick<
      TemplateSectionProps,
      "title" | "type" | "saved" | "selectable" | "renderWithEjs"
    >
  >;
} = {
  All: {},
  Saved: {
    title: "Saved",
    saved: true,
    selectable: true,
  },
  StaffPicks: {
    title: "Staff picks",
    type: "STAFF_PICKED",
  },
  Colorful: {
    title: "Colorful",
    type: "COLORFUL",
  },
  Professional: {
    title: "Professional",
    type: "PROFESSIONAL",
  },
  Minimalist: {
    title: "Minimalist",
    type: "MINIMALIST",
  },
  Automation: {
    title: "Automation",
    type: "AUTOMATION",
  },
  Favorites: {},
};

export function sectionPropsByFilter(filter: TemplateFilter) {
  return sectionPropsByFilterMap[filter];
}

export const filterOptions: { label: string; value: TemplateFilter }[] = [
  { label: "All templates", value: "All" },
  { label: "Saved", value: "Saved" },
  { label: "Staff picks", value: "StaffPicks" },
  { label: "Colorful", value: "Colorful" },
  { label: "Professional", value: "Professional" },
  { label: "Minimalist", value: "Minimalist" },
  { label: "Workflow", value: "Automation" },
];
